import { gql } from "graphql-tag";
import { PROMOTION_FIELDS } from "./Fragments";

export const GET_PROMOTION_RECIPIENTS = gql`
    query GetPromotionRecipients($id: Int!) {
        promotion_recipients(id: $id) {
            id
            name
            email
            phone_number
            economic_number
            customer_group
        }
    }
`;

export const GET_PROMOTIONS = gql`
    query GetPromotions($type: String) {
        promotions(type: $type) {
            ...PromotionFields
        }
    }
    ${PROMOTION_FIELDS}
`;

export default { GET_PROMOTIONS };
